// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"RequestsCount_tabWrapper__2EUE0","tab__count":"RequestsCount_tab__count__2HdC0"};